import * as _ from 'lodash';

import { FcProductName, FcProducts } from 'types/access';

import { BrandShopNavigationProducts, NavigationLink, RouteConfig } from './types';
import { brandShopFcProductPageRouteMapper } from '../utils';
import { FcProductSuites } from '../../brands/types';

export const brandShopNavigationDefaultLinksByFcProduct = (
    brandId
): Record<BrandShopNavigationProducts, NavigationLink> => ({
    [FcProductName.Landing]: {
        label: 'LANDING_PAGE.TITLE',
        route: { target: brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.Landing] },
        e2eHook: 'brand-shop-navigation-landing-button',
        hasChildren: false,
        index: 0
    },
    [FcProductName.OrderPlatform]: {
        label: 'ORDER_PLATFORM_PAGE.TITLE',
        route: {
            target: `${brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.Reorder]}/search`,
            queryParams: { minimumStock: '1' },
            routerLinkActiveOptions: {
                paths: 'subset',
                queryParams: 'ignored',
                matrixParams: 'exact',
                fragment: 'exact'
            }
        },
        e2eHook: 'brand-shop-navigation-reorder-button',
        hasChildren: false,
        index: 1
    },
    [FcProductName.PreorderPlatform]: {
        label: 'PREORDER_PLATFORM_PAGE.TITLE',
        route: { target: brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.Preorder] },
        e2eHook: 'brand-shop-navigation-preorder-button',
        hasChildren: false,
        index: 2
    },
    [FcProductName.Suggestions]: {
        label: 'ORDER_SUGGESTIONS.TITLE',
        route: { target: brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.Suggestions] },
        e2eHook: 'brand-shop-navigation-suggestions-button',
        hasChildren: false,
        index: 3
    },
    [FcProductName.AutoRestock]: {
        label: 'ORDER_AUTO_RESTOCK.TITLE',
        route: { target: brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.AutoRestock] },
        e2eHook: 'brand-shop-navigation-auto-restock-button',
        hasChildren: false,
        index: 4
    },
    [FcProductName.ContentPlatform]: {
        label: 'CONTENT_PAGE.TITLE',
        route: { target: brandShopFcProductPageRouteMapper(brandId)[FcProductSuites.Content] },
        e2eHook: 'brand-shop-navigation-content-button',
        hasChildren: true,
        index: 5
    }
});

export const parseRouteTargetToString = (url: RouteConfig['target']) => (Array.isArray(url) ? url.join('/') : url);

export const getNavigationLinksByFcProducts = (
    brandId: string,
    fcProducts: FcProducts,
    retailerId: string
): NavigationLink[] => {
    return _.reduce(
        fcProducts,
        (result, fcProductConfig, fcProductName) => {
            if (
                !fcProductConfig.participates ||
                (fcProductConfig.trialPeriod.active &&
                    !fcProductConfig.trialPeriod.allowedRetailers?.includes(retailerId))
            ) {
                return result;
            }

            const link = brandShopNavigationDefaultLinksByFcProduct(brandId)[fcProductName];
            if (!link) return result;
            return [...result, link];
        },
        []
    ).sort((a, b) => a?.index - b?.index);
};
